import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNote1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V14.5H14.5V21H3Z" fill="currentColor"/><Path d="M16 21H16.3107L21 16.3107V16H16V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNote1;
